var _rect, _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 137,
    viewBox: "0 0 194 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 32.5,
    width: 53,
    height: 53,
    rx: 26.5,
    transform: "rotate(90 89 32.5)",
    fill: "#F1EDF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.184 54.4995V86.3245C129.184 89.5753 130.475 92.6929 132.773 94.9913C135.073 97.2904 137.39 98.5816 140.641 98.5816H52.3555C55.6062 98.5816 57.9242 97.2904 60.2228 94.9913C62.5214 92.6929 63.8127 89.5753 63.8127 86.3245V53.8568C63.8127 45.1881 67.2564 36.8744 73.3862 30.7447C79.5158 24.615 87.8295 21.1714 96.4982 21.1714C103.355 21.1714 109.991 23.3262 115.498 27.2608",
    stroke: "url(#paint0_linear_8918_27267)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5,
    cy: 16,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 22.5 16)",
    fill: "#00FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.601 72.009C171.051 72.1737 171.05 72.826 170.601 72.9905C164.726 75.1413 162.641 77.2253 160.49 83.1008C160.326 83.5502 159.674 83.5504 159.509 83.101C157.357 77.2277 155.274 75.1438 149.399 72.991C148.949 72.8263 148.95 72.174 149.399 72.0095C155.274 69.8587 157.359 67.7747 159.51 61.8992C159.674 61.4498 160.326 61.4496 160.491 61.899C162.643 67.7723 164.726 69.8562 170.601 72.009Z",
    fill: "url(#paint1_linear_8918_27267)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96 20.5C99.3137 20.5 102 17.8137 102 14.5C102 11.1863 99.3137 8.5 96 8.5C92.6863 8.5 90 11.1863 90 14.5C90 17.8137 92.6863 20.5 96 20.5Z",
    stroke: "url(#paint2_linear_8918_27267)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.375 99.375C109.375 106.486 103.611 112.25 96.5 112.25C89.3893 112.25 83.625 106.486 83.625 99.375",
    stroke: "url(#paint3_linear_8918_27267)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144 8.5H160L144 32.5H160",
    stroke: "url(#paint4_linear_8918_27267)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119 32.5H131L119 48.5H131",
    stroke: "url(#paint5_linear_8918_27267)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8918_27267",
    x1: 139.638,
    y1: 59.242,
    x2: -0.265315,
    y2: 112.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8918_27267",
    x1: 171.727,
    y1: 72.3033,
    x2: 132.531,
    y2: 85.4961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8918_27267",
    x1: 101.864,
    y1: 14.4016,
    x2: 82.2657,
    y2: 20.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8918_27267",
    x1: 109.082,
    y1: 105.707,
    x2: 76.8643,
    y2: 127.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8918_27267",
    x1: 159.818,
    y1: 20.3033,
    x2: 132.122,
    y2: 26.5181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8918_27267",
    x1: 130.864,
    y1: 40.3688,
    x2: 110.353,
    y2: 45.5467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotifications);
export default __webpack_public_path__ + "static/media/no_notifications.8b5412d620f8d260ea9f8c0547a19ae3.svg";
export { ForwardRef as ReactComponent };